import { jsx as i } from "react/jsx-runtime";
import { useState as m } from "react";
import { clamp as f } from "../../services/utils/index.js";
import { useTranslation as $ } from "../../hooks/useTranslation/index.js";
import { RatingContainer as h, RatingButton as A, RatingStar as E } from "./style.js";
const u = 5, _ = ({
  value: c,
  editable: s,
  onRate: o,
  className: v,
  ...p
}) => {
  const { t: e } = $("common"), [g, l] = m(null), r = f(c, 0, u), [y, z] = m(!1), M = new Array(u).fill(0).map((a, n) => c - n).map((a) => f(a, 0, 1)), S = (a, n) => {
    const t = n + 1;
    return /* @__PURE__ */ i(
      A,
      {
        type: "button",
        onMouseEnter: () => {
          if (y || !s)
            return;
          const d = new Array(t).fill(1), T = new Array(u - t).fill(0);
          l(d.concat(T));
        },
        onMouseLeave: () => {
          s && l(null);
        },
        onClick: () => {
          if (r === t) {
            z(!0), l(null), o && o(0);
            return;
          }
          o && o(t);
        },
        title: t === r ? e("normalize-value-remove-vote") : t === 1 ? e("rating-star-value-one") : `${e("normalize-value-stars-vote")} ${t} ${e("normalize-value-stars")}`,
        disabled: !s,
        children: /* @__PURE__ */ i(
          E,
          {
            fillRate: a,
            "data-testid": `star-${t}`
          },
          n
        )
      },
      n
    );
  };
  return /* @__PURE__ */ i(
    h,
    {
      ...p,
      className: v,
      title: r === 0 ? e("normalize-value-no-vote") : r === 1 ? e("normalize-value-one-star") : `${r.toFixed(1).replace(".0", "")} ${e("normalize-value-stars")}`,
      children: (g || M).map(S)
    }
  );
};
export {
  _ as Rating
};
